import { render, staticRenderFns } from "./comrecommend.vue?vue&type=template&id=2dc464c5&scoped=true"
import script from "./comrecommend.vue?vue&type=script&lang=js"
export * from "./comrecommend.vue?vue&type=script&lang=js"
import style0 from "./comrecommend.vue?vue&type=style&index=0&id=2dc464c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc464c5",
  null
  
)

export default component.exports